const hexToRgb = hex =>
  hex
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => "#" + r + r + g + g + b + b
    )
    .substring(1)
    .match(/.{2}/g)
    .map(x => parseInt(x, 16));

var getCanvasImageData = function(imageBuffer, callback) {
  let dataArray = [];

  imageBuffer.forEach(hex => {
    const colors = hexToRgb(hex);
    dataArray.push(colors[0]);
    dataArray.push(colors[1]);
    dataArray.push(colors[2]);
    dataArray.push(0);
  });

  callback(null, dataArray);
};

var histogram = function(imageBuffer, callback) {
  if (["string", "object"].indexOf(typeof imageBuffer) === -1) {
    throw new TypeError("Expected imageBuffer to be a string or a buffer");
  }

  if (typeof callback !== "function") {
    throw new TypeError("Expected callback to be a function");
  }

  getCanvasImageData(imageBuffer, function(err, data) {
    if (err) {
      return callback(err);
    }

    var hist = {
        red: new Array(256),
        green: new Array(256),
        blue: new Array(256),
        alpha: new Array(256),

        colors: {
          rgb: 0,
          rgba: 0
        },

        palettes: {
          rgb: [],
          rgba: []
        },

        greyscale: true,
        alphachannel: false,
        max: 1024
      },
      red,
      green,
      blue,
      alpha,
      hexmap = {},
      hexamap = {},
      i;

    for (i = 0; i < 256; i += 1) {
      hist.red[i] = hist.green[i] = hist.blue[i] = hist.alpha[i] = 0;
    }

    for (i = 0; i < data.length; i += 4) {
      red = data[i];
      green = data[i + 1];
      blue = data[i + 2];
      alpha = data[i + 3];

      if (alpha < 255) {
        hist.alphachannel = true;
      }

      if ((hist.greyscale && red !== green) || red !== blue) {
        hist.greyscale = false;
      }

      hist.red[red] += 1;
      hist.green[green] += 1;
      hist.blue[blue] += 1;
      hist.alpha[alpha] += 1;

      var hexaString = (
          red * 0x1000000 +
          green * 0x10000 +
          blue * 0x100 +
          alpha
        ).toString(16),
        hexa = "#" + "0000000".substr(0, 8 - hexaString.length) + hexaString,
        hex = hexa.substr(0, 7);

      if (!(hex in hexmap)) {
        hexmap[hex] = 1;
        hist.palettes.rgb.push(hex);
        hist.colors.rgb += 1;
      } else {
        hexmap[hex] += 1;
      }

      if (!(hexa in hexamap)) {
        hexamap[hexa] = 1;
        hist.palettes.rgba.push(hexa);
        hist.colors.rgba += 1;
      } else {
        hexamap[hexa] += 1;
      }
    }

    hist.max = Math.max(...hist.red, ...hist.green, ...hist.blue)

    callback(null, hist);
  });
};

export default histogram;
